import { Component, OnInit } from '@angular/core';
import { DconConfigAPI } from 'src/app/features/dfte-grid-view/config/config';
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from '@angular/router';
import { CompareserviceService } from '../compareservice.service';
import { ConfigPopupComponent } from '../config-popup/config-popup.component';
import { NotificationService } from 'src/app/shared/components/notification/notification.service';
import { FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { HttpEventType } from '@angular/common/http';
import { DataService } from 'src/app/features/dfte-grid-view/config/data.service';
import { InfoPopupComponent } from 'src/app/shared/components/info-popup/info-popup.component';


@Component({
  selector: 'app-file-compare-submit',
  templateUrl: './file-compare-submit.component.html',
  styleUrls: ['./file-compare-submit.component.scss']
})
export class FileCompareSubmitComponent implements OnInit {
  instanceList: any;
  instanceListTarget: any;
  selectedInstance: any = 'File';
  targetInstance: any;
  batchKey: string;
  public tracks = [];
  public configData = [];
  showArray = [];
  public itemNumber = 0;
  instanceListDuplicate: any;
  dynamicVariable = true;
  selectedValue: string;
  public sourceVal = [];
  selOpt: boolean = true;
  public submitBtnEnable: boolean;
  public progressBarName = 'select';


  showArray1 = [];
  moduleName: any;


  selectedStartDate: string;
  startDate1 = new Date();
  startDate = new FormControl(new Date());
  tomorrow = new Date();
  endDate = new FormControl(new Date());
  dateVariable = true;
  date: any;
  configItem: any = [];
  public tasks = [];
  public configData1 = [];
  endDateReadonly = true;
  public submitNewBtnDisable: boolean = true;
  selectedEndDate: string;
  configTemplate: boolean = false;
  selected: any = [];
  selectedModule: any = [];
  isChecked = false;
  selectedFiles: any;
  fileName: any;
  fileUpload: string;
  fileUpload1: string;
  file: any;
  hideme = {};

  files: any[] = [{ WorkBook_Template: "Y", name: 'Use default template / BR100 file', checked: 'true' },
  { WorkBook_Template: "N", name: 'Upload Workbook file', checked: 'false' }];

  hideOptions: boolean = true;
  isDisabled: boolean = true;
  start: any;
  selectedFile: any;
  batchStatus: any;
  events: string[] = [];
  end: any;

  uploadForm: FormGroup;

  public projectId: string;
  public projectName: string;
  public options: any;
  fromTable: any = null;
  batchKeyDetails: any;
  editBtnDisable: boolean = false;
  public data: any = [];

  count: number = 0;
  public progressBarArray1 = [{ name: "select", src: 'assets/select.png', index: 0 },
  { name: "submit", src: 'assets/submit.png', index: 1 },
  { name: "compare", src: 'assets/Vector.png', index: 2 },
  ];
  instanceVariable = null;
  sourceInstanceList: any;
  myFiles: string[] = [];

  constructor(
    public dialog: MatDialog, private compareService: CompareserviceService, private router: Router,
    private route: ActivatedRoute, private notification: NotificationService, private formBuilder: FormBuilder, public _data: DataService
  ) {
    this.tomorrow.setDate(this.tomorrow.getDate());
    this.hideme = {};
  }

  ngOnInit(): void {
    if (this.compareService.projId == null) {
      this.router.navigate([""], { relativeTo: this.route });
    } else {
      this.getConfigDetails(DconConfigAPI.API_VARIABLES.Request_Type_Compare);
      this.getInstanceDetails(DconConfigAPI.API_VARIABLES.CLOUD);
      this.getSelectedInstanceDetails(DconConfigAPI.API_VARIABLES.FILE);
      this.selectedInstance = null;
      this.targetInstance = null;
    }
  }

  onInstanceChangeAtTargetSubmit(instance) {
    this.compareService.targetInstance = this.targetInstance;
  }

  onInstanceChangeAtSource(instance) {
    if (instance == null) {
      this.targetInstance = null;
      this.dynamicVariable = true;
    } else {
      this.dynamicVariable = false;
    }
  }

  onInstanceChangeAtTarget(instance) {
    this.compareService.targetInstance = this.targetInstance;
  }

  configPopUp(data, i) {
    this.selected.push(data.APPLICATION);
    this.selected = [...new Set(this.selected)];
    const dialogRef = this.dialog.open(ConfigPopupComponent, {
      width: "927px",
      height: "620px",
      data: {
        configData: Object.assign({}, data),
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result.savedData) {
        if (this.progressBarName === 'select') {
          this.progressBarName = 'submit';
          this.progressBarArray1[0].src = 'assets/complete.png';
          this.itemNumber = 1;
          this.uploadForm = this.formBuilder.group({
            fileData: [""],
          });
        } else if (this.progressBarName === 'compare') {
          this.progressBarName = 'submit';
          this.progressBarArray1[0].src = 'assets/complete.png';
          this.itemNumber = 1;
          this.editBtnDisable = false;
        } 
        this.setSelectedconfigData(result, this.configData);
        this.compareService.configObj = {
          tracks: this.tracks,
          configData: this.configData,
        };
        if (result.selectedConfigData.saveStatus === true) {
          if (data.APPLICATION === result.selectedConfigData.APPLICATION) {
            this.moduleName = result.selectedConfigData.APPLICATION;
            //disabled submit button on task update
            this.submitNewBtnDisable = true;
            result.selectedConfigData.file_uploaded = false;
            this.showArray1[i] = true;
          } else {
            this.showArray1[i] = false;
            //check if file is uploaded for all selected config
            if ((this.configData.filter(e => e.saveStatus === true).length) === (this.configData.filter(e => e.file_uploaded === true).length) &&
              (this.configData.filter(e => e.saveStatus === true).length) !== 0 &&
              (this.configData.filter(e => e.file_uploaded === true).length) !== 0) {
              this.submitNewBtnDisable = false;
            } else {
              this.submitNewBtnDisable = true;
            }
          }
        } else {
          this.showArray1[i] = false;
          //check if file is uploaded for all selected config
          if ((this.configData.filter(e => e.saveStatus === true).length) === (this.configData.filter(e => e.file_uploaded === true).length) &&
            (this.configData.filter(e => e.saveStatus === true).length) !== 0 &&
            (this.configData.filter(e => e.file_uploaded === true).length) !== 0) {
            this.submitNewBtnDisable = false;
          } else {
            this.submitNewBtnDisable = true;
          }
        }
      } else {
        this.compareService.configObj = {
          tracks: this.tracks,
          configData: this.configData,
        };
      }
    });
  }

  setSelectedconfigData(result, configObj) {
    const selConfigData = result.selectedConfigData;
    if (selConfigData.saveStatus === false) {
      selConfigData.file_uploaded = false;
      selConfigData.file_name = null;
    }
    configObj.forEach((element, index) => {
      if (selConfigData.TRACK === element.TRACK && selConfigData.APPLICATION === element.APPLICATION && selConfigData.APPLICATION_SHORT_CODE === element.APPLICATION_SHORT_CODE) {
        this.configData.splice(index, 1, selConfigData);
        this.myFiles[index] = "";
      }
    });
  }

  getInstanceDetails(type) {
    const data = [];
    this.compareService.getInstanceDetails(type).subscribe((res) => {
      res?.Instance_Details?.forEach((element) => {
        data.push(JSON.parse(element.details));
      });
      this.instanceList = data[0].INSTANCE;

      this.instanceListDuplicate = data[0].INSTANCE;
      this.instanceListTarget = data[0].INSTANCE;
      this.compareService.selectInstanceListTarget = this.instanceListTarget;
    }, error => {
      this.notification.showError('Something went wrong!');
    });
  }

  getSelectedInstanceDetails(type) {
    const data = [];
    this.compareService.getInstanceDetails(type).subscribe((res) => {
      res?.Instance_Details?.forEach((element) => {
        data.push(JSON.parse(element.details));
      });
      this.sourceInstanceList = data[0].INSTANCE;
      console.log("sourceInstanceList", this.sourceInstanceList);
    }, error => {
      this.notification.showError('Something went wrong!');
    });
  }

  getConfigDetails(type) {
    const data = [];
    this.compareService.getConfigDetails(type).subscribe((res) => {
      res?.Config_Details?.forEach((element) => {
        let task = [];
        const obj = JSON.parse(element.details);
        if (obj.TASK != null) {
          obj.TASK.forEach((ele) => {
            const taskObj = ele;
            taskObj["selectStatus"] = "n";
            task.push(taskObj);
          });
        } else {
          task = null;
        }
        const detailsObj = {
          TRACK: obj.TRACK,
          APPLICATION: obj.APPLICATION,
          APPLICATION_SHORT_CODE: obj.APPLICATION_SHORT_CODE,
          saveStatus: false,
          file_uploaded: false,
          file_name: null,
          TASK: task,
        };
        this.myFiles.push("");
        data.push(detailsObj);
      });
      this.configData = data;
      data.forEach((element, index) => {
        this.tracks.push(element.TRACK);
        this.showArray[index] = false;
      });

      this.configData.forEach((element, index) => {
        if (element.APPLICATION === element.APPLICATION_SHORT_CODE) {
          this.configData1.push(element.TRACK);
        }
      });
      this.tracks = [...new Set(this.tracks)];
      this.configData1 = [...new Set(this.configData1)];
    });
  }

  // *****************************************************************************************************************************

  onInstanceChange(instance) {

  }

  // check if the item are selected
  checked(item) {
    if (this.selected.indexOf(item) !== -1) {
      return true;
    }
  }

  // when checkbox change, add/remove the item from the array
  onChange(checked, item, arg) {
    if (item.saveStatus) {
      this.selected.push(item);
      this.tasks.push(arg);
      this.selected = [...new Set(this.selected)];
      this.submitNewBtnDisable = false;
    } else {
      this.selected.splice(this.selected.indexOf(item), 1);
      this.tasks.splice(this.tasks.indexOf(item), 1);
      this.submitNewBtnDisable = true;
    }
  }

  onFileInputClicked(fileInput, configItem, i) {
    fileInput.value = null;
    configItem.file_uploaded = false;
    configItem.file_name = null;
    this.myFiles[i] = "";
    //check if file is uploaded for all selected config
    if ((this.configData.filter(e => e.saveStatus === true)).length === (this.configData.filter(e => e.file_uploaded === true)).length) {
      this.submitNewBtnDisable = false;
    } else {
      this.submitNewBtnDisable = true;
    }
  }

  onFileSelectedForCsvExtract(event, application) {
    const format = ["xlsx"];
    if (event.target.files.length > 0 && (this.selected.length > 0 || this.selected.length === 1)) {
      const file = event.target.files[0];
      this.uploadForm.get("fileData").setValue(file);
    }
    const fileFormat = (event.target.files[0].name).substr((event.target.files[0].name).lastIndexOf('.') + 1);
    if (!format.includes(fileFormat)) {
      event.target.value = null;
      this.configData.map(e => {
        if (e.APPLICATION === application) {
          e.file_uploaded = false;
        }
        return e;
      });
      this.submitNewBtnDisable = true;
      this.notification.showError("Not a valid file format, xlsx file required");
    } else {
      this.configData.map((e, i) => {
        if (e.APPLICATION === application) {
          e.file_uploaded = true;
          e.file_name = event.target.files[0].name;
          this.myFiles[i] = event.target.files[0].name;
        }
        return e;
      });
      //check if file is uploaded for all selected config
      if ((this.configData.filter(e => e.saveStatus === true)).length === (this.configData.filter(e => e.file_uploaded === true)).length) {
        this.submitNewBtnDisable = false;
      }
      this.uploadFileForCsvExtract(application);
    }
  }

  async uploadFileForCsvExtract(application) {
    this._data.apiCallInProgress = true;
    document.getElementById("overlay").style.display = "block";
    const formData = new FormData();
    // formData.append("workbook_batchkey", this.batchKey);
    formData.append("batchkey", this.compareService.batchKey);
    formData.append("path", `${this._data.windowFileSharePath}${this._data.projectID}\\${DconConfigAPI.APPLICATION.toUpperCase()}\\`);
    formData.append("module", application);
    formData.append("csvExtract", 'true');
    formData.append("fileData", this.uploadForm.get("fileData").value);

    console.log("formData", formData);

    await (await this.compareService.uploadFileFromWorkbook(formData)).subscribe(async (message) => {
      switch (message.type) {
        case HttpEventType.Response:
          
          this._data.apiCallInProgress = false;
          document.getElementById("overlay").style.display = "none";
          this.createPopup();
          break;

      }
    },
      error => {
        this.submitNewBtnDisable = true;
        this._data.apiCallInProgress = false;
        document.getElementById("overlay").style.display = "none";
        this.notification.showError("Failed to upload workbook");
      });
  }
  addEvent() {
    this.endDateReadonly = false;
  }


  createPopup() {
    const dialogRef = this.dialog.open(InfoPopupComponent, {
      width: "917px",
      height: "220px",
      data: {
        type: 'Upload Status',
        mess: `<b>File uploaded successfully</b>`,
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result = 'ok') {
        this._data.apiCallInProgress = false;
        document.getElementById("overlay").style.display = "none";
      }
    });
  }


  getLineItems(configData) {
    const data = [];
    configData?.forEach((element) => {
      if (element.TASK != null && element.saveStatus) {
        element.TASK.forEach((ele) => {
          if (ele.selectStatus === "y" || ele.selectStatus === "Y") {
            const trackObj = {
              track: element.TRACK,
              applicationshortcode: element.APPLICATION_SHORT_CODE,
              taskname: ele.TASK_NAME,
              taskcode: ele.TASK_CODE,
            };
            data.push(trackObj);
          }
        });
      }
    });
    return data;
  }


  onSubmit() {
    const body = this.onConfigSubmit();
    this.compareService.onConfigSubmit(body).subscribe((res) => {
      this.batchKey = res.Batch_Key;
      this.compareService.batchKey = this.batchKey;
      if (res.Batch_Key) {
        const dialogRef = this.dialog.open(InfoPopupComponent, {
          width: "917px",
          height: "220px",
          data: {
            type: 'Task Status',
            mess: ` Batch Key ${res.Batch_Key}  :<b> New</b>`
          }
         
        });

        dialogRef.afterClosed().subscribe((result) => {
          if ((result = "ok")) {
            this.resetShowArray();
            this.progressBarName = 'compare';
            this.progressBarArray1[0].src = 'assets/complete.png';
            this.progressBarArray1[1].src = 'assets/complete.png';
            this.itemNumber = 3;        
          }
        });
      } else {
        alert(res.Result);
      }
    },
      (error) => {
        this.notification.showError('Something went wrong!');
      });
  }

  onConfigSubmit() {
    const body = {
      batchkey: this.compareService.batchKey ? this.compareService.batchKey : "",
      projectname: this.compareService.projId,
      requestedby: this.compareService.requestedBy,
      targetinstance: this.targetInstance.INSTANCE,
      sourceinstance: this.selectedInstance.INSTANCE,
      filesharepath: this.compareService.getfileSharePath(),
      requesttype: DconConfigAPI.API_VARIABLES.Request_Type_Compare,
      extracttype: DconConfigAPI.API_VARIABLES.Extract_Type_SQL,
      instanceid: this.selectedInstance.INSTANCE_ID.toString(),
      targetinstanceid: this.targetInstance.INSTANCE_ID.toString(),
      LineItems: this.getLineItems(this.configData),
      comparisonType: 'File'
    };
    return body;
  }

  resetShowArray() {
    this.showArray.forEach((e, i) => {
      this.showArray[i] = false;
    });
  }


  editConfig() {
    this.tracks.forEach((val1, index) => {
      this.configData.forEach((val2, index2) => {
        if (val1 === val2.TRACK && val2.saveStatus) {
          this.showArray[index] = true;
        }
      });
    });
    this.editBtnDisable = true;

  }

  async onCompareClick() {
    this._data.apiCallInProgress = true;
    document.getElementById("overlay").style.display = "block";
    await (await this.compareService.onSubmitForCompare(this.batchKey)).subscribe(async (message) => {
      switch (message.type) {
        case HttpEventType.Response:
          const body = {
            "batchkey": this.batchKey,
            "requesttype": DconConfigAPI.API_VARIABLES.Request_Type_Compare,
            "processtrigger": "Y"
          }
          this.compareService.onCreateAndCompareUpdate(body).subscribe((res) => {
            this.unMaskPage();
            this.comparePopup();
          }, error => {
            this.unMaskPage();
            this.notification.showError('Something went wrong!');
            this.router.navigate(['/config-compare'])
          })
          break;
      }
    },
      error => {
        this._data.apiCallInProgress = false;
        document.getElementById("overlay").style.display = "none";
        this.notification.showError("Failed to generate Compare");
      });
  }

  maskPage() {
    this._data.apiCallInProgress = true;
    document.getElementById("overlay").style.display = "block";
  }

  unMaskPage() {
    this._data.apiCallInProgress = false;
    document.getElementById("overlay").style.display = "none";
  }

  comparePopup() {
    const dialogRef = this.dialog.open(InfoPopupComponent, {
      width: "917px",
      height: "220px",
      data: {
        type: 'Task Status',
        mess: `Batch Key ${this.compareService.batchKey}  :<b> File Compare - Process Submitted</b>`,
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result = 'ok') {
        this.router.navigate(['/config-compare']);
      }
    });
  }
}
